// extracted by mini-css-extract-plugin
export default {"skill":"Skills_skill__+UX9o"};